import { useQuery } from '@tanstack/react-query';
import { endpoints } from '@rossum/api-client';
import { UsersListQuery } from '@rossum/api-client/users';
import { useApiClient } from '../../lib/apiClient';

export const QUERY_KEY_USERS = 'users';

export const useUsers = (
  query: UsersListQuery = {},
  options: { enabled?: boolean } = {}
) => {
  const api = useApiClient();
  return useQuery({
    queryKey: [QUERY_KEY_USERS, query] as const,
    queryFn: ({ queryKey }) => api.request(endpoints.users.list(queryKey[1])),
    keepPreviousData: true,
    enabled: options.enabled,
  });
};
